(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5116],{

/***/ 40086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgWellDone = function SvgWellDone(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 131,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m122.621 94.754-11.943-9.157H20.905A14.273 14.273 0 0 1 6.573 71.265V19.512A14.271 14.271 0 0 1 20.905 5.18h95.744a14.269 14.269 0 0 1 13.257 8.838 14.26 14.26 0 0 1 1.075 5.494v70.862a5.109 5.109 0 0 1-2.723 4.972 5.115 5.115 0 0 1-5.637-.592Z",
    fill: "#C3DDFD"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m117.048 90.574-11.943-9.157H15.332A14.271 14.271 0 0 1 1 67.085V15.332A14.272 14.272 0 0 1 15.332 1h95.943a14.272 14.272 0 0 1 14.332 14.332v70.863a5.31 5.31 0 0 1-2.891 4.903 5.315 5.315 0 0 1-5.668-.524v0Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M81.616 33.844a18.313 18.313 0 0 1-36.625 0M23.294 33.844a4.777 4.777 0 0 1 9.555 0M93.758 33.844a4.777 4.777 0 1 1 9.555 0",
    stroke: "#1D4ED8",
    strokeWidth: 1.705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgWellDone);

/***/ }),

/***/ 2748:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magic-link",
      function () {
        return __webpack_require__(6425);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L8": function() { return /* binding */ buttonSize; },
/* harmony export */   "ZP": function() { return /* binding */ Button; },
/* harmony export */   "uX": function() { return /* binding */ buttonColor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(370);
/* harmony import */ var _basic_Spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84240);



var buttonColor = {
    primary: "text-white bg-gray-800 hover:bg-black focus:ring-gray-300 dark:text-gray-900 dark:bg-gray-50 dark:hover:bg-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 ",
    alternative: "text-gray-900 bg-white border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
    borderless: "text-gray-900 bg-white hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
    danger: "text-white bg-red-700 hover:bg-red-800 focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900",
    link: "underline hover:no-underline active:no-underline focus:no-underline cursor-pointer text-gray-800 underline-offset-2 dark:text-gray-300",
    transparent: "bg-transparent focus:ring-transparent p-0"
};
var buttonSize = {
    "no-size": "p-0 m-0",
    "extra-small": "py-2 px-3 text-xs ",
    small: "py-2 px-3 text-sm ",
    base: "px-2 lg:px-5 py-2 lg:py-2.5 text-sm",
    large: "py-3 px-5 text-base",
    "extra-large": "px-6 py-3.5 text-base "
};
function Button(param) {
    var children = param.children, _color = param.color, color = _color === void 0 ? "primary" : _color, _size = param.size, size = _size === void 0 ? "base" : _size, className = param.className, _type = param.type, type = _type === void 0 ? "button" : _type, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _loadingMessage = param.loadingMessage, loadingMessage = _loadingMessage === void 0 ? "" : _loadingMessage, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _disabled = param.disabled, disabled = _disabled === void 0 ? loading : _disabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(buttonColor[color], buttonSize[size], "font-bold rounded-lg focus:z-10 focus:ring-2", className, {
            "flex items-center justify-center gap-3": loading
        }),
        type: type,
        onClick: onClick,
        disabled: disabled,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_Spinner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    className: "!w-6 !h-6"
                }),
                loadingMessage
            ]
        }) : children
    });
}


/***/ }),

/***/ 4683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Label(param) {
    var htmlFor = param.htmlFor, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
        htmlFor: htmlFor,
        className: "block mb-2 text-sm font-bold text-gray-900 dark:text-gray-300 ".concat(className),
        children: children
    });
}


/***/ }),

/***/ 45214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99730);




var states = {
    primary: "bg-gray-50 border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ",
    error: ""
};
var errorClass = "bg-red-100 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:bg-red-100 dark:border-red-400";
function TextInput(param) {
    var id = param.id, name = param.name, _type = param.type, type = _type === void 0 ? "text" : _type, _state = param.state, state = _state === void 0 ? "primary" : _state, _errorText = param.errorText, errorText = _errorText === void 0 ? "" : _errorText, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, className = param.className, register = param.register, onChange = param.onChange, placeholder = param.placeholder, min = param.min, max = param.max, value = param.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                id: id
            }, onChange && {
                onChange: onChange
            }, register && register(name)), {
                disabled: disabled,
                type: type,
                placeholder: placeholder,
                className: "".concat(states[state], " ").concat(errorText ? errorClass : "", " ").concat(disabled ? "text-gray-500" : "", " shadow-sm border text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:shadow-sm-light ").concat(className)
            }), min && {
                min: min
            }, max && {
                max: max
            }, value && {
                value: value
            })),
            errorText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                variant: "error",
                className: "mt-2 text-sm text-red-600 dark:text-red-500",
                children: errorText
            }) : ""
        ]
    });
}


/***/ }),

/***/ 96543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuccessAction; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Heading_Heading2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51859);
/* harmony import */ var _elements_Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99730);
/* harmony import */ var _svgs_illustrations_well_done_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40086);




function SuccessAction(param) {
    var headerTitle = param.headerTitle, text = param.text, _extraHtml = param.extraHtml, extraHtml = _extraHtml === void 0 ? null : _extraHtml;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svgs_illustrations_well_done_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "mx-auto"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Heading_Heading2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: headerTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: text
            }),
            extraHtml
        ]
    });
}


/***/ }),

/***/ 6425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MagicLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(51351);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87536);
/* harmony import */ var _components_elements_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74340);
/* harmony import */ var _components_elements_Forms_Label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4683);
/* harmony import */ var _components_elements_Forms_TextInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45214);
/* harmony import */ var _components_elements_Heading_Heading2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51859);
/* harmony import */ var _components_elements_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6553);
/* harmony import */ var _components_elements_Paragraph__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99730);
/* harmony import */ var _components_modules_Layout_BasicLayout_BasicCardLayout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6475);
/* harmony import */ var _components_modules_Seo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12400);
/* harmony import */ var _components_modules_SuccessAction__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96543);
/* harmony import */ var _config_routes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6635);
/* harmony import */ var _features_auth__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15768);

















function MagicLink(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined), isSuccess = ref1[0], setIsSuccess = ref1[1];
    var ref2 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_14__/* .useForm */ .cI)(), register = ref2.register, handleSubmit = ref2.handleSubmit, errors = ref2.formState.errors;
    function onSubmit(data) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(data) {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsSuccess(undefined);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,_features_auth__WEBPACK_IMPORTED_MODULE_12__/* .sendMagicLink */ .pr)(data.email)
                        ];
                    case 2:
                        _state.sent();
                        setIsSuccess(true);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setIsSuccess(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _onSubmit.apply(this, arguments);
    }
    if (isSuccess === true) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_modules_Layout_BasicLayout_BasicCardLayout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_modules_Seo__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    title: "Demande de lien de connexion",
                    description: "Nous vous envoyons un e-mail avec un lien pour vous connecter sans mot de passe sur Partager.",
                    url: _config_routes__WEBPACK_IMPORTED_MODULE_11__/* ["default"].login.getUrl */ .Z.login.getUrl(),
                    isCanonical: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_modules_SuccessAction__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    headerTitle: "E-mail envoy\xe9 !",
                    text: "L'e-mail contenant un lien de connexion a \xe9t\xe9 envoy\xe9."
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_modules_Layout_BasicLayout_BasicCardLayout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_modules_Seo__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                title: "Demande de lien de connexion",
                description: "Nous vous envoyons un e-mail avec un lien pour vous connecter sans mot de passe sur Partager.",
                url: _config_routes__WEBPACK_IMPORTED_MODULE_11__/* ["default"].login.getUrl */ .Z.login.getUrl()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Heading_Heading2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: "!mt-0",
                level: 1,
                children: "Demande de lien de connexion"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Paragraph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: "mb-6",
                children: "Entrer votre adresse e-mail et nous vous enverrons un lien pour vous connecter \xe0 votre compte."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Forms_Label__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                htmlFor: "email",
                                children: "Adresse e-mail"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Forms_TextInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                name: "email",
                                id: "email",
                                type: "email",
                                className: "w-full",
                                register: register,
                                errorText: (ref = errors.email) === null || ref === void 0 ? void 0 : ref.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        type: "submit",
                        className: "!w-full mb-6",
                        children: "Envoyer un lien de connexion"
                    }),
                    isSuccess === false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Paragraph__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "error",
                        children: "Une erreur s'est produite, veuillez r\xe9essayer"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    href: _config_routes__WEBPACK_IMPORTED_MODULE_11__/* ["default"].login.getUrl */ .Z.login.getUrl(),
                    children: "Annuler"
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5525,1664,7536,6904,6193,9774,2888,179], function() { return __webpack_exec__(2748); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);